module.exports = __webpack_public_path__ + "static/vue-c3111b2bc6d29a9652e05214a5dbdb40.svg";